import React from "react";

import { ReactComponent as DnLogo } from "../../../../assets/icons/dnlogo.svg";

export function Header({leftBarOpened}) {
	
	return (
		<div className="leftSideHeader">

			{
				leftBarOpened ? (
					<div className={leftBarOpened ? "logo" : "logo is-hidden"}>
						<DnLogo />
					</div>	
				) : 
				(
					<div className="logo-closed-hidden" />
				)
			}
		</div>
	)
}
